import { useState, useCallback } from "react";

type AuthView = "signin" | "signup" | "verify" | "forgot" | "reset" | "invite";

interface AuthValidation {
  emailError: boolean;
  passwordError: boolean;
  confirmPasswordError: boolean;
  codeError: boolean;
  setEmailError: (v: boolean) => void;
  setPasswordError: (v: boolean) => void;
  setConfirmPasswordError: (v: boolean) => void;
  setCodeError: (v: boolean) => void;
  validateInputs: (params: {
    view: AuthView;
    email: string;
    password: string;
    confirmPassword: string;
    checkPassword?: boolean;
  }) => boolean;
  clearErrors: () => void;
}

export function useAuthValidation(): AuthValidation {
  const [emailError, setEmailError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [confirmPasswordError, setConfirmPasswordError] = useState(false);
  const [codeError, setCodeError] = useState(false);

  const clearErrors = useCallback(() => {
    setEmailError(false);
    setPasswordError(false);
    setConfirmPasswordError(false);
    setCodeError(false);
  }, []);

  const validateInputs = useCallback(
    ({
      view,
      email,
      password,
      confirmPassword,
      checkPassword = true,
    }: {
      view: AuthView;
      email: string;
      password: string;
      confirmPassword: string;
      checkPassword?: boolean;
    }): boolean => {
      let isValid = true;

      if (view !== "invite" && !email) {
        setEmailError(true);
        isValid = false;
      }
      if (checkPassword && !password) {
        setPasswordError(true);
        isValid = false;
      }
      if ((view === "signup" || view === "invite") && !confirmPassword) {
        setConfirmPasswordError(true);
        isValid = false;
      }
      if ((view === "signup" || view === "invite") && password !== confirmPassword) {
        setConfirmPasswordError(true);
        isValid = false;
      }
      return isValid;
    },
    []
  );

  return {
    emailError,
    passwordError,
    confirmPasswordError,
    codeError,
    setEmailError,
    setPasswordError,
    setConfirmPasswordError,
    setCodeError,
    validateInputs,
    clearErrors,
  };
}
